import fifthaveClient from "./fifthaveClient"

function getMerchants() {
  return fifthaveClient.get('api/v1/merchants?_all=true')
}

function getMerchantDetail(merchantId) {
  return fifthaveClient.get(`/api/v1/merchants/${merchantId}`)
}

export { getMerchants, getMerchantDetail }
